// Утилиты для Form1

import { parseDecimal } from '../../../utils/decimalUtils';

// Функция для форматирования площади (8 знаков до точки, 4 после)
export const formatArea = (value) => {
  if (!value || value === '') return '0.0000';
  const num = parseDecimal(value);
  if (isNaN(num)) return '0.0000';
  
  // Ограничиваем до 8 знаков до точки
  if (num >= 100000000) {
    return '99999999.0000';
  }
  
  return num.toFixed(4);
};

// Функция для валидации площади (8 знаков до точки, 4 после)
export const validateArea = (value) => {
  if (!value) return false;
  const num = parseDecimal(value);
  if (isNaN(num)) return false;
  if (num <= 0) return false;
  if (num >= 100000000) return false;
  return true;
};

// Функция для форматирования протяжённости (9 знаков до точки, 3 после)
export const formatLength = (value) => {
  if (!value || value === '') return '0.000';
  const num = parseDecimal(value);
  if (isNaN(num)) return '0.000';
  
  // Ограничиваем до 9 знаков до точки
  if (num >= 1000000000) {
    return '999999999.000';
  }
  
  return num.toFixed(3);
};

// Функция для валидации протяжённости (9 знаков до точки, 3 после)
export const validateLength = (value) => {
  if (!value) return false;
  const num = parseDecimal(value);
  if (isNaN(num)) return false;
  if (num < 0) return false;
  if (num >= 1000000000) return false;
  return true;
};

// Функция для валидации площади лесопатологического выдела
export const validateLpArea = (value, taxArea = 0) => {
  if (!value) return false;
  const num = parseDecimal(value);
  if (isNaN(num)) return false;
  if (num <= 0) return false;
  if (num >= 100000000) return false;
  
  // Проверяем, что площадь лесопатологического выдела не превышает площадь лесотаксационного выдела
  if (taxArea > 0 && num > taxArea) {
    return false;
  }
  
  return true;
};

